export function Footer() {
  return (
    <footer className="bg-rcallen-brown-border border-t-2 border-rcallen-brown-border">
      <div className="max-w-4xl mx-auto px-4 py-3">
        <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-rcallen-white font-secondary text-sm">
          {/* Left side - Company info */}
          <div className="text-center md:text-left">
            <span className="font-bold">KELLY MANUFACTURING CO.</span>
            <span className="ml-2">555 S. TOPEKA WICHITA, KS. 67202</span>
          </div>
          
          {/* Right side - Contact info */}
          <div className="text-center md:text-right">
            <span>PHONE: 316-265-6868 FAX: 316-265-6687 EMAIL: </span>
            <a 
              href="mailto:info@kellymfg.com" 
              className="text-rcallen-yellow hover:text-rcallen-yellow/80 font-bold uppercase"
            >
              info@kellymfg.com
            </a>
          </div>
        </div>
        
        {/* Copyright notice */}
        <div className="text-center mt-2 text-rcallen-white font-secondary text-xs">
          Copyright © 2026 Kelly Manufacturing Company
        </div>
      </div>
    </footer>
  );
}